import { Chip } from "@mui/material"

export function RateCardTag({ item, index, getTagProps }) {
    return <Chip label={item.name} size="small" color="primary" {...getTagProps({ index })} />
}
